<template>
    <div class="list-body" @click="gotoDetail">
        <div class="list-body-top">
            <div class="list-body-top-left">
                <img :src="item.icon" :onerror="bindOwnImg(item.id)">
                <!--                <p v-if='item.cmptType==="算法赛" && pageType!="index"'>{{ $t('dc_lang.算法赛') }}</p>-->
                <!--                <p v-else-if='item.type==="结果提交型" && pageType=="index"'>{{ $t('dc_lang.算法赛') }}</p>-->
                <!--                <p v-else class='type2'>{{ $t('dc_lang.创意赛') }}</p>-->
                <p class="type2">{{ item.cmptAttr }}</p>
            </div>
            <div class="list-body-top-right">
                <div class="competition-title">
                    <div class="tag" v-if="item.cmptType === '1'">邀请赛</div>
                    {{ item.cmptName }}
                </div>
                <p class="competition-organization">{{ item.hostName }}</p>
            </div>
        </div>
        <div class="list-body-bottom">
            <div class="competition-award" :class="item.id=='320'? 'hidden':''">
                <span>{{ $t('dc_lang.奖金池') }}:</span>
                <div>
                    <span class='text'>{{ item.reward }}</span>
                </div>
            </div>
            <span class="competition-status red">{{ item.cmptStatus }}</span>
            <!--      <span class="competition-status red" v-if='item.miniAppState===2'>{{$t('dc_lang.进行中')}}</span>-->
            <!--      <span class="competition-status green" v-if='item.miniAppState===3'>{{$t('dc_lang.可参与')}}</span>-->
            <!--      <span class="competition-status gray" v-if='item.miniAppState===4'>已完结</span>-->
        </div>
    </div>
</template>

<script>
export default {
    name: 'competition-item',
    props: {
        item: {
            type: Object
        },
        pageType: ''
    },
    watch: {
        item: {
            handler (val) {
                if (val.cmptType === '2') {
                    val.reward = val.ztsList[0].reward
                    val.hostName = val.introduction
                }
            },
            deep: true,
            immediate: true
        }
    },
    data () {
        return {}
    },
    methods: {
        errorListImg (num) {
            return 'https://pu-datacastle.oss-cn-qingdao.aliyuncs.com/master.third.source/cmptmini/img/listbanner/' + num + '.jpg'
        },
        bindOwnImg (_errId) {
            if (!_errId) return
            let num = _errId.toString().slice(_errId.toString().length - 1, _errId.toString().length)
            return 'this.src=' + '"' + this.errorListImg(num) + '"'
        },
        gotoDetail: function () {
            let data = {
                name: this.item.name,
                customPage: this.item.custom_page || this.item.customPage,
                id: this.item.id,
                item:this.item
            }
            this.$emit('go-detail', data)
        }
    }
}
</script>

<style scoped lang="scss">
.list-body {
    padding: 30px 30px 0;
    margin-bottom: 20px;
    background-color: #ffffff;

    .list-body-top {
        display: flex;
        padding-bottom: 30px;
        border-bottom: 2px solid rgba(0, 0, 0, 0.08);

        .list-body-top-left {
            width: 240px;
            height: 160px;
            position: relative;
            border-radius: 6px;
            overflow: hidden;
            margin-right: 30px;

            img {
                width: 100%;
            }

            p {
                position: absolute;
                right: 0;
                bottom: 0;
                min-width: 70px;
                padding: 0 13px;
                white-space: nowrap;
                height: 42px;
                line-height: 42px;
                text-align: center;
                font-size: 22px; /*px*/
                border-radius: 6px 0 0 0;
                color: #FFFFFF;
                background: #FFB746;
            }

            p.type2 {
                background: #FF6138;
            }
        }

        .list-body-top-right {
            flex: 1;

            .tag {
                //width: 38px;
                //height: 16px;
                background: linear-gradient(135deg, #51ADFC 0%, #5170FC 100%);
                border-radius: 1px;
                font-size: 10px;
                font-weight: 400;
                color: #FFFFFF;
                //line-height: 16px;
                text-align: center;
                display: inline;
                padding: 5px 10px;
            }

            .competition-title {
                font-size: 32px; /*px*/
                line-height: 42px;
                color: #17181A;
                margin-bottom: 18px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .competition-organization {
                font-size: 24px; /*px*/
                color: #797C80;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-word;
            }
        }
    }

    .list-body-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 96px;

        .competition-award {
            font-size: 28px; /*px*/
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;
            text-align: left;
            color: #797C80;
        }

        .competition-award.hidden {
            visibility: hidden;
        }

        .money {
            font-size: 22px; /*px*/
        }

        .text {
            font-size: 38px; /*px*/
            color: #FF6B55;
            float: left;
            max-width: 400px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
        }

        .competition-status {
            font-size: 28px; /*px*/
            text-align: right;
        }

        .red {
            color: #FF6B55;
        }

        .green {
            color: #46D684;
        }

        .gray {
            color: #BDC1C7;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/competition/competition-item/competition-item.vue